// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibDialog_old-container__xb1Og {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibDialog_old-container__xb1Og.nibDialog_wrap__RhSl5 {
  flex-wrap: wrap;
}
.nibDialog_old-container__xb1Og .nibDialog_box__MZFHq.nibDialog_col__iUJdM {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibDialog_old-container__xb1Og .nibDialog_box__MZFHq.nibDialog_col__iUJdM > div {
  width: 100%;
}
.nibDialog_old-container__xb1Og .nibDialog_box__MZFHq.nibDialog_row__U8KLv {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibDialog_old-container__xb1Og form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibDialog_old-container__xb1Og form > .nibDialog_box__MZFHq.nibDialog_col__iUJdM {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibDialog_old-container__xb1Og form > .nibDialog_box__MZFHq.nibDialog_col__iUJdM {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibDialog_old-container__xb1Og, .nibDialog_col__iUJdM, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibDialog_old-container__xb1Og, .nibDialog_col__iUJdM, form {
    padding: 0px;
  }
}
.nibDialog_text-overflow-hidden__uUMs5 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibDialog_icon__xP8mx {
  color: var(--accent-color);
}

.nibDialog_richtext-output-wrap__9\\+RQj .nibDialog_se-video-container__XuSTo figure {
  padding-bottom: 0 !important;
}

.nibDialog_wrap__RhSl5 {
  padding: 20px;
  backdrop-filter: blur(4px);
}
.nibDialog_wrap__RhSl5 .nibDialog_papper__R-4zW {
  margin: 0;
  background-color: #232323;
  width: 480px;
  border-radius: 12px;
  box-shadow: -5px 5px 10px 0px rgba(0, 0, 0, 0.35);
  max-width: unset;
}
.nibDialog_wrap__RhSl5 .nibDialog_papper__R-4zW .nibDialog_title__7uJMa {
  padding-top: 30px;
}
.nibDialog_wrap__RhSl5 .nibDialog_papper__R-4zW .nibDialog_title__7uJMa .nibDialog_header__ChxtP h3 {
  font-weight: 500;
  color: #fff;
  line-height: 20px;
}
.nibDialog_wrap__RhSl5 .nibDialog_papper__R-4zW .nibDialog_title__7uJMa .nibDialog_header__ChxtP p {
  font-weight: 300;
  color: rgba(255, 255, 255, 0.6);
  font-size: 80%;
  text-indent: 5px;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibDialog/nibDialog.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,aAAA;EACA,0BAAA;AA4EJ;AA3EI;EACI,SAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EDDN,iDAAA;ECGM,gBAAA;AA6ER;AA5EQ;EACI,iBAAA;AA8EZ;AA5EgB;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;AA8EpB;AA7EgB;EACI,gBAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;AA+EpB","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../sass/settings'\r\n\r\n.wrap\r\n    padding: 20px\r\n    backdrop-filter: blur(4px)\r\n    .papper\r\n        margin: 0\r\n        background-color: #232323\r\n        width: 480px\r\n        border-radius: 12px\r\n        +shadow()\r\n        max-width: unset\r\n        .title\r\n            padding-top: 30px\r\n            .header\r\n                h3\r\n                    font-weight: 500\r\n                    color: #fff\r\n                    line-height: 20px\r\n                p\r\n                    font-weight: 300\r\n                    color: rgba(#fff, .6)\r\n                    font-size: 80%\r\n                    text-indent: 5px\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibDialog_old-container__xb1Og`,
	"wrap": `nibDialog_wrap__RhSl5`,
	"box": `nibDialog_box__MZFHq`,
	"col": `nibDialog_col__iUJdM`,
	"row": `nibDialog_row__U8KLv`,
	"text-overflow-hidden": `nibDialog_text-overflow-hidden__uUMs5`,
	"icon": `nibDialog_icon__xP8mx`,
	"richtext-output-wrap": `nibDialog_richtext-output-wrap__9+RQj`,
	"se-video-container": `nibDialog_se-video-container__XuSTo`,
	"papper": `nibDialog_papper__R-4zW`,
	"title": `nibDialog_title__7uJMa`,
	"header": `nibDialog_header__ChxtP`
};
export default ___CSS_LOADER_EXPORT___;
